module.exports = __webpack_public_path__ + "static/media/18_tn.00974e13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/18_tn.jpg
// module id = 156
// module chunks = 0